module.exports = __webpack_public_path__ + "static/media/e-class@2x.fc3b6a33.png";